import React from 'react';
import PropTypes from 'prop-types';

const Close = props => {
  if (props.close && props.onClick) {
    return (
      <a className="pxl-alert__close" aria-label="Close" onClick={props.onClick}>
        <span>&times;</span>
      </a>
    );
  }
  return null;
};

Close.propTypes = {
  close: PropTypes.bool,
  onClick: PropTypes.func
};

export default Close;
